import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IIconProps from "./type";
import stylesheet, {
    getIconMirrored,
    getIconColor,
    getIconSize,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../core/hooks";

const Icon: FC<IIconProps> = ({
    isMirrored: isMirroredProp,
    "aria-label": ariaLabel,
    icon: IconComponentProp,
    accessibilityLabel,
    size = "medium",
    color = "mid",
    customColor,
    customTheme,
    style,
    ...props
}) => {
    const {
        iconSizes,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        direction
    } = NCoreUIKitLocalize.useContext();

    const currentLabel = ariaLabel ?? accessibilityLabel;

    const isDecorative = !currentLabel;

    const currentSize = getIconSize({
        iconSizes,
        size
    });

    const currentColor = getIconColor({
        customColor,
        colors,
        color
    });

    const isMirrored = getIconMirrored({
        isMirrored: isMirroredProp,
        icon: IconComponentProp
    });

    const {
        container: containerDynamicStyle
    } = useStyles({
        size: currentSize,
        isMirrored,
        direction
    });

    return <View
        {...props}
        aria-hidden={isDecorative ? true : undefined}
        role={isDecorative ? undefined : "img"}
        accessible={!isDecorative}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-label={currentLabel}
    >
        <IconComponentProp
            color={currentColor}
            size={currentSize}
        />
    </View>;
};
export default Icon;
